import { render } from "./aside.vue?vue&type=template&id=29829083&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"

import "./aside.vue?vue&type=style&index=0&id=29829083&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29829083"

export default script